/*
  File: src/components/store/ProductGrid.jsx
  Purpose: Responsive grid wrapper to lay out product cards.
  Props: { children: ReactNode }
*/
import React from 'react';

/**
 * ProductGrid
 * Simple responsive grid wrapper for product cards.
 */
function ProductGrid({ children }) {
    return (
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
            {children}
        </div>
    );
}

export default ProductGrid;


